<template lang="pug">
v-container
    v-dialog(v-model="show" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable max-width="700" persistent)
        v-card.pa-0(flat)
            v-card-title {{ invoice.name }}
            //v-tabs(v-model="tab")
                v-tab {{ $t('billingPage.detailTabLabel') }}
                v-tab {{ $t('billingPage.paymentsTabLabel') }}
            v-card-text.flex-shrink-0.flex-grow-1.pb-0(style="height: 60vh;")
                InvoiceDetailTab(:invoice="invoiceDetail")
                //v-tabs-items(v-model="tab")
                    v-tab-item

                    //v-tab-item
                        v-card(flat tile)
                            v-card-text.px-0.pb-0
                                v-list.pt-0(v-if="paymentsDetailList && paymentsDetailList.invoicePayments")
                                    v-list-item(three-line v-for="(item, idx) in paymentsDetailList.invoicePayments", :key="idx")
                                        v-col.pa-0(cols="9" xl="6" lg="6" md="9" sm="9")
                                            v-list-item-title.title {{getName(item.sourceKind)}}
                                            v-list-item-title {{getFormattedDate(item.paymentsFromTransaction[0].datePosted)}}
                                            v-list-item-subtitle {{formattedIban(item.paymentsFromTransaction[0].fromIban)}}
                                            v-list-item-title {{item.paymentsFromTransaction[0].reference}}
                                        v-col.pa-0(cols="3" xl="6" lg="6" md="3" sm="3")
                                            v-list-item-content.title.justify-end {{getPriceTotal(item.amount)}} €
            v-divider
            v-card-actions
                v-spacer
                v-btn.pr-2(color="primary" @click="onCloseButtonClick") {{ $t('billingPage.closeButtonLabel') }}

</template>

<script lang="ts">
import Vue from 'vue'
import {Action} from 'vuex-class'
import {Component, Prop} from 'vue-property-decorator'
import InvoiceDetailTab from '@/components/invoice-detail/InvoiceDetailTab.vue'
import {FETCH_INVOICE_DETAIL} from '@/store/action-types'
import {Invoice} from '@/model/Invoice'

@Component({
  components: {
    InvoiceDetailTab
  }
})
export default class InvoiceDetailDialog extends Vue {
  @Prop({type: Boolean, default: false}) readonly show!: boolean
  @Prop({type: Object, required: true}) readonly invoice!: Invoice

  @Action(FETCH_INVOICE_DETAIL) fetchInvoiceDetail!: ({ (payload: Invoice): Promise<Invoice> })

  private fetchInProgress = false
  private invoiceDetail: Invoice | null = null
  private tab: number | null = null

  onCloseButtonClick(): void {
    this.$emit('close')
  }

  async fetchData() {
    try {
      this.fetchInProgress = true
      this.invoiceDetail = await this.fetchInvoiceDetail(this.invoice)

      console.debug(this.invoiceDetail)
    } catch (e) {
      // TODO
    } finally {
      this.fetchInProgress = true
    }
  }

  mounted(): void {
    this.fetchData()
  }
}
</script>

<style lang="stylus" scoped>
</style>
